import React from "react";
export default function Pdf() {
  return (
    <svg
      width="18px"
      height="24px"
      viewBox="0 0 18 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Pdf</title>
      <g
        id="SitePges"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Zazmic_KnowledgeExtraction"
          transform="translate(-379.000000, -617.000000)"
          fill="#FA332A"
          fillRule="nonzero"
        >
          <g id="Group-9-Copy" transform="translate(355.000000, 565.000000)">
            <g id="file-pdf" transform="translate(24.000000, 52.000000)">
              <path
                d="M4.125,14.25 L3.75,14.25 L3.75,12 L4.125,12 C4.7484375,12 5.25,12.5015625 5.25,13.125 C5.25,13.7484375 4.7484375,14.25 4.125,14.25 Z M9,12 L9.375,12 C9.7875,12 10.125,12.3375 10.125,12.75 L10.125,15.75 C10.125,16.1625 9.7875,16.5 9.375,16.5 L9,16.5 L9,12 Z M10.5,0 L10.5,6 C10.5,6.8296875 11.1703125,7.5 12,7.5 L18,7.5 L18,21 C18,22.6546875 16.6546875,24 15,24 L3,24 C1.34296875,24 0,22.6546875 0,21 L0,3 C0,1.34296875 1.34296875,0 3,0 L10.5,0 Z M3,10.5 C2.585625,10.5 2.25,10.8375 2.25,11.25 L2.25,17.25 C2.25,17.6625 2.585625,18 3,18 C3.414375,18 3.75,17.6625 3.75,17.25 L3.75,15.75 L4.125,15.75 C5.5734375,15.75 6.75,14.5734375 6.75,13.125 C6.75,11.6765625 5.5734375,10.5 4.125,10.5 L3,10.5 Z M7.5,17.25 C7.5,17.6625 7.8375,18 8.25,18 L9.375,18 C10.6171875,18 11.625,16.9921875 11.625,15.75 L11.625,12.75 C11.625,11.5078125 10.6171875,10.5 9.375,10.5 L8.25,10.5 C7.8375,10.5 7.5,10.8375 7.5,11.25 L7.5,17.25 Z M13.5,10.5 C13.0875,10.5 12.75,10.8375 12.75,11.25 L12.75,17.25 C12.75,17.6625 13.0875,18 13.5,18 C13.9125,18 14.25,17.6625 14.25,17.25 L14.25,15 L15.75,15 C16.1625,15 16.5,14.6625 16.5,14.25 C16.5,13.8375 16.1625,13.5 15.75,13.5 L14.25,13.5 L14.25,12 L15.75,12 C16.1625,12 16.5,11.6625 16.5,11.25 C16.5,10.8375 16.1625,10.5 15.75,10.5 L13.5,10.5 Z M12,0 L18,6 L12,6 L12,0 Z"
                id="Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
export function Facebook() {
  return (
    <svg
      width="8px"
      height="14px"
      viewBox="0 0 8 14"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Facebook</title>
      <g
        id="ProductRecommendationPage"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="ProductRecommendation"
          transform="translate(-181.000000, -815.000000)"
          fill="#FFFFFF"
          fillRule="nonzero"
        >
          <g id="Group-10" transform="translate(167.000000, 804.000000)">
            <g id="facebook-f" transform="translate(14.250000, 11.250000)">
              <path
                d="M6.7565918,7.59375 L7.1315332,5.15056641 L4.78722656,5.15056641 L4.78722656,3.56510742 C4.78722656,2.89669922 5.11470703,2.24516602 6.16464844,2.24516602 L7.23041016,2.24516602 L7.23041016,0.165058594 C7.23041016,0.165058594 6.26326172,0 5.33856445,0 C3.40795898,0 2.14602539,1.17017578 2.14602539,3.28851563 L2.14602539,5.15056641 L0,5.15056641 L0,7.59375 L2.14602539,7.59375 L2.14602539,13.5 L4.78722656,13.5 L4.78722656,7.59375 L6.7565918,7.59375 Z"
                id="Path"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
export function Instagram() {
  return (
    <svg
      width="14px"
      height="14px"
      viewBox="0 0 14 14"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Instagram</title>
      <g
        id="ProductRecommendationPage"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="ProductRecommendation"
          transform="translate(-268.000000, -815.000000)"
          fill="#FFFFFF"
          fillRule="nonzero"
        >
          <g id="Group-10" transform="translate(167.000000, 804.000000)">
            <g id="Group-15-Copy-3" transform="translate(90.000000, 0.000000)">
              <g id="instagram" transform="translate(11.250000, 11.250000)">
                <path
                  d="M6.75301238,3.2887705 C4.837136,3.2887705 3.29178289,4.83412362 3.29178289,6.75 C3.29178289,8.66587638 4.837136,10.2112295 6.75301238,10.2112295 C8.66888876,10.2112295 10.2142419,8.66587638 10.2142419,6.75 C10.2142419,4.83412362 8.66888876,3.2887705 6.75301238,3.2887705 Z M6.75301238,9.00025103 C5.51492246,9.00025103 4.50276135,7.99110231 4.50276135,6.75 C4.50276135,5.50889769 5.51191007,4.49974897 6.75301238,4.49974897 C7.99411469,4.49974897 9.00326342,5.50889769 9.00326342,6.75 C9.00326342,7.99110231 7.99110231,9.00025103 6.75301238,9.00025103 L6.75301238,9.00025103 Z M11.1631429,3.14718844 C11.1631429,3.59603369 10.8016568,3.95450742 10.3558239,3.95450742 C9.90697869,3.95450742 9.54850496,3.59302131 9.54850496,3.14718844 C9.54850496,2.70135557 9.90999107,2.33986946 10.3558239,2.33986946 C10.8016568,2.33986946 11.1631429,2.70135557 11.1631429,3.14718844 Z M13.4555673,3.96655696 C13.4043568,2.88511101 13.1573413,1.92717282 12.3650842,1.13792815 C11.5758396,0.348683477 10.6179014,0.101667968 9.53645543,0.0474450519 C8.42187326,-0.0158150173 5.08113913,-0.0158150173 3.96655696,0.0474450519 C2.8881234,0.0986555841 1.93018521,0.345671092 1.13792815,1.13491576 C0.345671092,1.92416044 0.101667968,2.88209863 0.0474450519,3.96354457 C-0.0158150173,5.07812674 -0.0158150173,8.41886087 0.0474450519,9.53344304 C0.0986555841,10.614889 0.345671092,11.5728272 1.13792815,12.3620719 C1.93018521,13.1513165 2.88511101,13.398332 3.96655696,13.4525549 C5.08113913,13.515815 8.42187326,13.515815 9.53645543,13.4525549 C10.6179014,13.4013444 11.5758396,13.1543289 12.3650842,12.3620719 C13.1543289,11.5728272 13.4013444,10.614889 13.4555673,9.53344304 C13.5188274,8.41886087 13.5188274,5.08113913 13.4555673,3.96655696 Z M12.0156477,10.7293596 C11.7806817,11.3197869 11.3258117,11.7746569 10.732372,12.0126353 C9.84371862,12.3650842 7.73504965,12.2837499 6.75301238,12.2837499 C5.77097512,12.2837499 3.65929376,12.3620719 2.77365279,12.0126353 C2.18322548,11.7776693 1.72835546,11.3227993 1.49037711,10.7293596 C1.13792815,9.84070624 1.21926252,7.73203726 1.21926252,6.75 C1.21926252,5.76796274 1.14094053,3.65628138 1.49037711,2.77064041 C1.72534308,2.1802131 2.1802131,1.72534308 2.77365279,1.48736472 C3.66230615,1.13491576 5.77097512,1.21625014 6.75301238,1.21625014 C7.73504965,1.21625014 9.84673101,1.13792815 10.732372,1.48736472 C11.3227993,1.72233069 11.7776693,2.17720071 12.0156477,2.77064041 C12.3680966,3.65929376 12.2867622,5.76796274 12.2867622,6.75 C12.2867622,7.73203726 12.3680966,9.84371862 12.0156477,10.7293596 Z"
                  id="Shape"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
export function Twitter() {
  return (
    <svg
      width="12px"
      height="14px"
      viewBox="0 0 12 11"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Twitter</title>
      <g
        id="ProductRecommendationPage"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="ProductRecommendation"
          transform="translate(-224.000000, -817.000000)"
          fill="#FFFFFF"
          fillRule="nonzero"
        >
          <g id="Group-10" transform="translate(167.000000, 804.000000)">
            <g id="Group-15-Copy" transform="translate(45.000000, 0.000000)">
              <g id="twitter" transform="translate(12.000000, 13.500000)">
                <path
                  d="M10.7665264,2.42893136 C10.7741436,2.53552553 10.7741436,2.64214313 10.7741436,2.7487373 C10.7741436,6 8.29953242,9.74621776 3.77666319,9.74621776 C2.3832515,9.74621776 1.08884019,9.34264587 0,8.64216657 C0.197977336,8.66499479 0.388314017,8.672612 0.59390857,8.672612 C1.74363962,8.672612 2.80203438,8.28429799 3.64721737,7.6218579 C2.5659944,7.59900625 1.65989711,6.89088629 1.34770839,5.91625749 C1.5,5.9390857 1.65227989,5.95432013 1.81219458,5.95432013 C2.03300013,5.95432013 2.25382912,5.92385127 2.45940023,5.87057762 C1.33249739,5.64213141 0.487290966,4.65229161 0.487290966,3.45685725 L0.487290966,3.42641182 C0.814690682,3.60915472 1.19543436,3.72336611 1.59895937,3.7385771 C0.936519283,3.29694257 0.5025254,2.54314275 0.5025254,1.69034254 C0.5025254,1.23349701 0.624330564,0.81471412 0.837542334,0.449228317 C2.04821113,1.94161696 3.86802292,2.91622233 5.90861683,3.02283993 C5.87055418,2.84009703 5.84770253,2.64976035 5.84770253,2.45940023 C5.84770253,1.10405119 6.94415994,0 8.30710276,0 C9.01522272,0 9.65481115,0.296954285 10.1040629,0.776651471 C10.6598854,0.670057305 11.1928797,0.464462752 11.6649831,0.182742901 C11.4822167,0.753823257 11.0939027,1.23352044 10.5837601,1.53806851 C11.0786917,1.48479486 11.5583889,1.34770839 12,1.15737171 C11.6650299,1.64466267 11.2462236,2.07865656 10.7665264,2.42893136 Z"
                  id="Path"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
export function Linkedin() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="14"
      viewBox="0 5 1036 990"
      id="linkedin"
      fill="#FFFFFF"
    >
      <path d="M0 120c0-33.334 11.667-60.834 35-82.5C58.333 15.833 88.667 5 126 5c36.667 0 66.333 10.666 89 32 23.333 22 35 50.666 35 86 0 32-11.333 58.666-34 80-23.333 22-54 33-92 33h-1c-36.667 0-66.333-11-89-33S0 153.333 0 120zm13 875V327h222v668H13zm345 0h222V622c0-23.334 2.667-41.334 8-54 9.333-22.667 23.5-41.834 42.5-57.5 19-15.667 42.833-23.5 71.5-23.5 74.667 0 112 50.333 112 151v357h222V612c0-98.667-23.333-173.5-70-224.5S857.667 311 781 311c-86 0-153 37-201 111v2h-1l1-2v-95H358c1.333 21.333 2 87.666 2 199 0 111.333-.667 267.666-2 469z"></path>
    </svg>
  );
}

export function Upload() {
  return (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Upload</title>
      <g
        id="KalendarAI"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="KalendarAI_List"
          transform="translate(-167.000000, -471.000000)"
          fill="white"
          fillRule="nonzero"
        >
          <g id="Group-2" transform="translate(167.000000, 465.000000)">
            <path
              d="M21.3333333,6 C22.8,6 24,7.2 24,8.66666667 L24,27.3333333 C24,28.8 22.8,30 21.3333333,30 L2.66666667,30 C1.2,30 0,28.8 0,27.3333333 L0,8.66666667 C0,7.2 1.2,6 2.66666667,6 Z M6.69333333,23.3333333 L2.66666667,23.3333333 L2.66666667,27.3333333 L21.3333333,27.3333333 L21.3333333,23.3333333 L17.3066667,23.3333333 C16.08,24.9466667 14.1733333,26 12,26 C9.82666667,26 7.90666667,24.9466667 6.69333333,23.3333333 Z M21.3333333,8.66666667 L2.66666667,8.66666667 L2.66666667,20.6666667 L8.24,20.6666667 C8.8,22.2133333 10.2533333,23.3333333 12,23.3333333 C13.7466667,23.3333333 15.2133333,22.2133333 15.76,20.6666667 L21.3333333,20.6666667 L21.3333333,8.66666667 Z M12,10 L17.3333333,15.3333333 L15.4533333,17.2133333 L13.3333333,15.1066667 L13.3333333,20.6666667 L10.6666667,20.6666667 L10.6666667,15.1066667 L8.54666667,17.2133333 L6.66666667,15.3333333 L12,10 Z"
              id="Combined-Shape"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}
